/* 📦 LIBS */
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

/* 🔗 SERVICE */
import { UserServices } from "../../Services/userServices/index.js";

/* 🎨 STYLES */
import { Container, Title } from "./styles";

const ConfirmaEmail = () => {
    const { t } = useTranslation();

    document.title = t("confirm-email.document-title");
    const { token } = useParams();
    const navigate = useNavigate();

    const SendToken = async() => {
        const Services = new UserServices();
        await Services.sendEmailToken(token);
        navigate("/");
    }

    SendToken()
    

    return (
        <Container>
            <Title>{t("confirm-email.title")}</Title>
        </Container>
    );
}

export default ConfirmaEmail;


